import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';
import type { FC } from 'react';

import { WidgetCard } from './widget-card';

export const TopContributorsWidgetSkeleton: FC = () => (
  <WidgetCard title="Top Contributors">
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
      {[0, 1, 2].map(index => (
        // oxlint-disable-next-line react/jsx-key
        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <Skeleton variant="circular" width={28} height={28} />
          <Box sx={{ flex: 1 }}>
            <Skeleton variant="text" width="70%" height={16} />
            <Skeleton variant="text" width="50%" height={12} />
          </Box>
        </Box>
      ))}
    </Box>
  </WidgetCard>
);
